import React from 'react';
import { getAspectRatio } from '../../common/lib/aspect-ratio';
import type { ImageSourceOptions } from '../../common/lib/image-source';
import { getImageSource } from '../../common/lib/image-source';
import { adImage as c } from '../../component-classes';
import type { Image } from '../../types';

type AdImageProps = {
    alt: string;
    adaptive?: boolean;
    crop?: boolean;
    aspectClass?: string;
    imageClass?: string;
    options?: ImageSourceOptions;
} & Omit<
    Image,
    // omit alt here, because we don't want alt text to be optional
    'alt'
>;

function AdImage(props: AdImageProps) {
    const {
        alt,
        adaptive = false,
        crop = false,
        aspectClass = '',
        imageClass = '',
        url,
        path,
        height,
        width,
        aspectRatio,
        sizes,
        options,
        ...imgProps
    } = props;

    const aspectRatioClassNames = `${
        adaptive
            ? getAspectRatio({
                  aspectRatio,
                  height,
                  width,
              })
            : ''
    } ${aspectClass}`;

    const { src, srcSet } = getImageSource(
        {
            url,
            path,
            width,
        },
        options,
    );

    const imageSourceProps = setupImageSourceProps(src, srcSet, sizes);
    return (
        <div className={aspectRatioClassNames}>
            <img
                alt={alt}
                className={`${c.image} ${
                    crop ? c.crop : c.contain
                } ${imageClass}`}
                loading="lazy"
                {...imageSourceProps}
                {...imgProps}
            />
        </div>
    );
}

function setupImageSourceProps(src: string, srcSet?: string, sizes?: string) {
    const hasValidImageSource = Boolean(srcSet) && Boolean(sizes);
    if (hasValidImageSource) {
        return { src, srcSet, sizes };
    } else {
        return { src };
    }
}

export default AdImage;
